export interface TeamMember {
  id: string; // User ID from users table
  name: string;
  email: string;
  role: string; // Custom role - can be any string (e.g., "Backend Engineer", "Lead", "DevOps")
  avatar?: string;
}

// Common role suggestions for UI
export const COMMON_TEAM_ROLES = [
  'Lead',
  'Developer',
  'Backend Engineer',
  'Frontend Engineer',
  'Full Stack Engineer',
  'DevOps Engineer',
  'Designer',
  'QA Engineer',
  'Product Manager',
  'Engineering Manager',
] as const;

export interface TeamLink {
  name: string;
  url: string;
  type: 'jira' | 'confluence' | 'github' | 'slack' | 'wiki' | 'documentation' | 'other';
}

export interface Team {
  id: string;
  name: string;
  description: string;
  lead: string;
  members: TeamMember[];
  servicesCount: number;
  services?: Array<{ id: string; name: string }>;
  email?: string;
  tags: string[];
  projects?: string[];
  links?: TeamLink[];
  isLocked: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTeamData {
  name: string;
  description: string;
  lead: string;
  members?: TeamMember[];
  email?: string;
  tags: string[];
  projects?: string[];
  links?: TeamLink[];
}

export interface UpdateTeamData extends Partial<CreateTeamData> {
}

export interface TeamFormData {
  name: string;
  description: string;
  tags: string[];
  email?: string;
  lead: string;
  projects?: string[];
  members?: TeamMember[];
  links?: TeamLink[];
}